import Button from "@/components/base/Button";
import type { ProductItem } from "@/pages/home/types";
import { withUtm } from "@/utils/shopUrl";

interface ProductCardProps {
  product: ProductItem;
}

export default function ProductCard({ product }: ProductCardProps) {
  return (
    <article className="reveal flex h-full flex-col overflow-hidden rounded-2xl border border-background-200 bg-background-50">
      <div className="w-full overflow-hidden bg-background-200">
        <img
          src={product.image}
          alt={product.alt}
          title={`${product.name} — Iokus Guatapé`}
          loading="lazy"
          className="w-full object-cover object-top aspect-[4/5]"
        />
      </div>

      <div className="flex flex-1 flex-col p-5 md:p-6">
        <h3 className="text-lg font-semibold leading-snug md:text-xl">{product.name}</h3>

        <div className="mt-3 flex flex-wrap gap-2">
          {product.tags.map((tag) => (
            <span
              key={tag}
              className="rounded-full bg-secondary-100 px-3 py-1 text-xs font-label font-semibold text-secondary-900"
            >
              {tag}
            </span>
          ))}
        </div>

        <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
          {product.description}
        </p>

        <div className="mt-auto pt-5">
          <Button
            href={withUtm(product.url)}
            variant="primary"
            external
            ariaLabel={`Ver ${product.name} en la tienda online`}
            fbEvent="ClicTiendaOnline"
            fbLabel={product.id || "generico"}
            className="w-full"
          >
            Ver en la tienda online
            <i className="ri-arrow-right-up-line text-base" aria-hidden="true"></i>
          </Button>
        </div>
      </div>
    </article>
  );
}